export const ProjectArr = [
  {
    title: "HUWIN App",
    category: "Real Estate Relation",
    tech: ["Symfony", "DDD", "MySQL", "ReactJS"],
    description:
      "A scalable CRM platform for real estate professionals, built with Symfony, Domain-Driven Design (DDD), and React.js to streamline customer engagement, relationship management, and review generation.",
    contributions: [
      "Backend Architecture & API Development",
      "REST API Development with Symfony",
      "Domain-Driven Design (DDD)",
      "Scalable CRM Architecture",
      "Customer Relationship Management",
      "Customer Engagement Workflows",
      "Review Generation & Management",
      "React.js Integration",
      "Cross-Functional Team Collaboration",
    ],
    website: "https://apps.apple.com/in/app/huwin/id6484405078",
  },
  {
    title: "AI-Powered Autonomous Telegram Deal Processing Agent",
    category: "Marketing Automation",
    tech: ["Python", "GPT-40", "Telethon", "Telegram API", "Cron Job"],
    description:
      "An LLM-powered Agentic AI platform for autonomously monitoring competitor Telegram deals, analyzing and filtering relevant products, processing affiliate links, and reposting optimized deals using Python and GPT-4o.",
    contributions: [
      "LLM-Powered Agentic Workflow",
      "Autonomous Telegram Channel Monitoring",
      "GPT-4o-Based Deal Analysis & Classification",
      "Amazon & Flipkart URL Processing",
      "Intelligent Affiliate Link Transformation",
      "AI-Driven Content Optimization",
      "Automated Deal Reposting",
      "Tool-Based Agent Execution",
      "Cron-Based Task Scheduling",
      "Telegram API & Telethon Integration",
    ],
    website: "",
  },
  {
    title: "Hiscraves",
    category: "Manufacturing ERP",
    tech: ["Laravel", "CakePHP", "MySQL", "React", "Python"],
    description:
      "A manufacturing and e-commerce ecosystem for a leading apparel brand, featuring production management, inventory control, market research, and operational analytics.",
    contributions: [
      "Manufacturing Workflow Automation",
      "Inventory Management",
      "Printing Cost Calculation",
      "Survey Platform Development",
      "Telegram Automation",
      "Product Classification System",
      "Gate Pass Management",
    ],
    website: "https://www.hiscraves.com",
  },
  {
    title: "Menrocks Survey",
    category: "Survey Platform",
    tech: ["React", "Laravel API"],
    description:
      "An interactive survey platform built to collect customer insights and market feedback through a modern and engaging user experience.",
    contributions: [
      "React Application Development",
      "REST API Integration",
      "Survey Management",
      "Data Collection",
      "User Engagement Features",
    ],
    website: "https://menrocks-survey.sevenrocks.in",
  },
  {
    title: "The Library",
    category: "Digital Music E-Commerce",
    tech: ["Laravel", "MySQL", "WeChat Pay"],
    description:
      "A digital music marketplace for purchasing and downloading songs with secure online payments.",
    contributions: [
      "Digital Product Marketplace",
      "Music Download Management",
      "WeChat Pay Integration",
      "Order Processing",
      "Customer Purchase Workflow",
    ],
    website: "",
  },
  {
    title: "B1st Ticketing System",
    category: "Customer Support",
    tech: ["CodeIgniter", "WordPress", "MySQL"],
    description:
      "A flexible ticketing solution designed to integrate with websites and popular CMS platforms, enabling efficient customer support and issue tracking.",
    contributions: [
      "Ticket Management System",
      "CMS Integration",
      "Customer Support Workflow",
      "Plugin Development",
      "Cross-Platform Compatibility",
    ],
    website: "https://github.com/egy1st/b1st-ticketing-system",
  },
  {
    title: "West Bengal University of Animal and Fishery Sciences (WBUAFS)",
    category: "Education ERP",
    tech: ["CodeIgniter", "MariaDB"],
    description:
      "A comprehensive ERP solution designed to manage academic operations, examinations, attendance, payroll, and institutional workflows.",
    contributions: [
      "Attendance Management",
      "Academic Management",
      "Timetable Management",
      "Examination Module",
      "Payroll Management",
      "ERP Development",
    ],
    website: "https://wbuafscl.ac.in",
  },
  {
    title: "Gandhi Institute of Engineering and Technology (GIET)",
    category: "Education ERP",
    tech: ["CodeIgniter", "MariaDB"],
    description:
      "An enterprise-grade ERP platform developed to streamline academic administration, staff management, examinations, and payroll operations.",
    contributions: [
      "Attendance Management",
      "Academic Records",
      "Timetable Scheduling",
      "Examination Management",
      "Payroll Processing",
      "ERP System Development",
    ],
    website: "https://www.giet.edu",
  },
  {
    title: "Kingston Educational Institute (KEI)",
    category: "Education ERP",
    tech: ["CodeIgniter", "MariaDB"],
    description:
      "A multi-institution ERP platform designed to manage academic and administrative processes across multiple educational organizations under the Kingston group.",
    contributions: [
      "Multi-Institute Management",
      "Attendance Tracking",
      "Academic Administration",
      "Timetable Management",
      "Examination Processing",
      "Payroll Management",
    ],
    website: "https://keical.edu.in",
  },
  {
    title: "Gauhati Law Times Online (GLT Online)",
    category: "Legal Research Platform",
    tech: ["CodeIgniter", "MySQL", "RazorPay"],
    description:
      "A legal research and e-commerce platform that enables lawyers and legal professionals to search citations, statutes, judgments, and purchase legal publications online.",
    contributions: [
      "Advanced Search Engine",
      "Citation Search System",
      "Subscription Management",
      "Role-Based Access Control",
      "E-Commerce Module",
      "Legal Database Management",
    ],
    website: "https://www.gltonline.co.in",
  },
  {
    title: "Nippon Florists",
    category: "E-Commerce",
    tech: ["CodeIgniter", "MySQL", "PayPal"],
    description:
      "A japanese e-commerce platform enabling customers to purchase flowers, cakes, and personalized gifts with secure online payments and streamlined order fulfillment.",
    contributions: [
      "E-Commerce Development",
      "PayPal Payment Integration",
      "Order Management",
      "Product Catalog Management",
      "Customer Purchase Workflow",
      "Delivery Tracking System",
    ],
    website: "https://www.nipponflorist.jp",
  },
  {
    title: "Cricket Association of Bengal (CAB)",
    category: "Sports Management",
    tech: ["PHP", "MySQL"],
    description:
      "Developed a comprehensive cricket management platform for players, fans, and administrators.",
    contributions: [
      "Membership Management",
      "Event Registration",
      "News Publishing",
      "Bengali Content Delivery",
    ],
    website: "https://www.cricketassociationofbengal.com",
  },
];
